// extracted by mini-css-extract-plugin
export default {"MultipleRoundSpinnerWrapper":"multipleRoundSpinner_MultipleRoundSpinnerWrapper__NRBYp"};